export interface SeoMeta {
    path: string;
    title: string;
    description: string;
    robots: string;
    sitemapEligible: boolean;
    isDynamic?: boolean;
    ogImage?: string;
    ogImageAlt?: string;
}

export const SEO_BASE_URL = 'https://www.dasee.ai';

const ogImg = (file: string) => `${SEO_BASE_URL}/og/${file}`;

const homeDesc =
    '다시는 롤렉스·오메가·까르띠에 등 명품 시계를 비대면으로 수선하는 전문 플랫폼. 정품 보증, 1:1 견적, 안전한 택배 수거.';
const serviceIntroDesc =
    '다시의 비대면 명품 시계 수선 서비스. 무료 견적, 정품 부품, 수선 보증, 전국 무료 택배 수거. 롤렉스·오메가·까르띠에·태그호이어 등 주요 브랜드 모두 대응합니다.';
const guideDesc =
    '명품 시계 오버홀 주기, 무브먼트 점검, 가죽줄 교체, 방수 점검 등 시계 관리법과 다시의 비대면 수선 서비스 이용 방법을 단계별로 안내합니다.';
const termsDesc =
    '다시(Dasee) 명품 수선 플랫폼의 서비스 이용약관입니다. 회원 가입, 결제, 수선 서비스 이용 등에 관한 권리와 의무를 안내합니다.';
const privacyDesc =
    '다시(Dasee)는 회원의 개인정보를 안전하게 보호합니다. 수집·이용 목적, 보관 기간, 제3자 제공 여부, 이용자 권리에 대한 처리방침을 확인하세요.';
const refundDesc =
    '다시(Dasee) 명품 수선 서비스의 환불 기준, 절차, 처리 기간 안내. 수선 전 취소·수선 후 불만족 시 환불 정책을 명확히 확인하세요.';
const repairCaseDesc =
    '롤렉스·오메가·까르띠에 등 명품 시계 수선 사례를 브랜드·품목별로 기록하는 페이지입니다. 수선 내용, 전후 결과, 작업 방법을 직접 확인할 수 있습니다.';

export const seoMetaList: SeoMeta[] = [
    {
        path: '/',
        title: '다시 | 명품 시계 비대면 수선 플랫폼 — Dasee',
        description: homeDesc,
        robots: 'index, follow, max-image-preview:large',
        sitemapEligible: true,
        ogImage: ogImg('home-hero.png'),
        ogImageAlt: homeDesc,
    },
    {
        path: '/service-intro',
        title: '명품 시계 수선 견적 — 다시 비대면 수선 서비스 소개',
        description: serviceIntroDesc,
        robots: 'index, follow, max-image-preview:large',
        sitemapEligible: true,
        ogImage: ogImg('service-intro-hero.png'),
        ogImageAlt: serviceIntroDesc,
    },
    {
        path: '/guide',
        title: '명품 시계 관리·수선 이용 가이드 — 다시',
        description: guideDesc,
        robots: 'index, follow, max-image-preview:large',
        sitemapEligible: true,
        ogImage: ogImg('og-default.png'),
        ogImageAlt: guideDesc,
    },
    {
        path: '/policy/terms',
        title: '이용약관 — 다시(Dasee)',
        description: termsDesc,
        robots: 'index, follow',
        sitemapEligible: true,
        ogImage: ogImg('og-default.png'),
        ogImageAlt: termsDesc,
    },
    {
        path: '/policy/privacy',
        title: '개인정보처리방침 — 다시(Dasee)',
        description: privacyDesc,
        robots: 'index, follow',
        sitemapEligible: true,
        ogImage: ogImg('og-default.png'),
        ogImageAlt: privacyDesc,
    },
    {
        path: '/policy/refund',
        title: '환불정책 — 다시(Dasee) 명품 수선',
        description: refundDesc,
        robots: 'index, follow',
        sitemapEligible: true,
        ogImage: ogImg('og-default.png'),
        ogImageAlt: refundDesc,
    },
    {
        path: '/repair-case',
        title: '명품 시계 수선 사례 — 다시(Dasee)',
        description: repairCaseDesc,
        robots: 'index, follow, max-image-preview:large',
        sitemapEligible: true,
        ogImage: ogImg('og-default.png'),
        ogImageAlt: repairCaseDesc,
    },
    {
        path: '/guide/detail',
        title: '이용 가이드 상세 — 다시',
        description: '명품 시계 관리·수선 이용 가이드 상세 페이지입니다.',
        robots: 'noindex, follow',
        sitemapEligible: false,
        isDynamic: true,
    },
];

export const seoMetaByPath: Record<string, SeoMeta> = Object.fromEntries(seoMetaList.map(m => [m.path, m]));
